var $ = require( 'jquery' );
var easing = require( 'jquery-easing');
var sub = require( './utility.js' );
/*
================================================================================
* javascript information
* file name  : main.js (トップページ固有のスクリプト)
================================================================================
*/
$(function() {
    var url = window.location.pathname;
    $('.navgation__item a[href="..'+url+'"]').parent().addClass('navgation__link_state_current');

    $('.navgation__item').hover(
      function () {
        $(this).addClass('navgation__link_state_hover');
      },
      function () {
        $(this).removeClass('navgation__link_state_hover');
      }
    );
    if(url.match('/company/')){
            // グローバル変数の定義
            var map = null ;    // 地図のインスタンス
            var markers = [] ;    // マーカーのインスタンス
            var infoWindows = [] ;    // 情報ウィンドウのインスタンス

            // 地図の出力
            function initialize(){
              /* 変数の定義 */
              var canvas , latlng , mapOptions , markerOption ;
              canvas = document.getElementById( 'map_canvas' );

              /* 中心座標を、LatLngクラスで用意する（座標） */
              latlng = new google.maps.LatLng( 43.059396, 141.380382 );

              /* Mapクラスのオプションを設定する */
              mapOptions = {
                zoom: 17 ,        //ズーム値
                center: latlng ,    //中心座標 [LatLngクラスで指定]
              } ;

              map = new google.maps.Map( canvas , mapOptions ) ;

              markerOption = {
                map: map ,  // マーカーを設置する地図
                position: latlng ,  // 位置座標 [LatLngクラスで指定]
                anchorPoint: new google.maps.Point( 0 , -24 ) , // アンカーポイント
              } ;

              markers[0] = new google.maps.Marker( markerOption ) ;
              // infoWindows[0].open( map , markers[0] ) ;
            }

            /* ページのロード後に関数[initialize()]を実行する */
            google.maps.event.addDomListener( window , 'load' , initialize ) ;
    }
});